<template>
	<container class="search-home" style="padding-top: 0px !important">
		<div
			justify="center"
			align="start"
			class="hero mb-10 pb-6"
			:style="{
				backgroundImage: `url(${heroImage})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat'
			}"
		>
			<v-col cols="8" class="pt-8">
				<h1 class="text-center mt-5" style="font-size: 2.25rem">
					Support Your Passion
				</h1>
				<h2
					class="mt-5 mb-5 text-center"
					style="font-size: 18px; font-weight: 400 !important"
				>
					Explore over 1 million nonprofits you can donate to through
					RoundUp App.
				</h2>
				<div style="width: 100%" class="px-2" @click="scrollToTop">
					<Search
						class="mb-5"
						:searchOnly="true"
						defaultSearchBarMinWidth="100px"
						breakpoint="xs"
						ref="searchbar"
					/>
				</div>
				<p
					@click="onFeelingLucky"
					class="pa-0 ma-0"
					style="cursor: pointer; color: #2553cd"
				>
					Feeling lucky?
				</p>
			</v-col>
		</div>
		<div v-if="hasUUID && featuredOrg" class="pl-4 pr-4">
			<p style="font-size: 1.5rem; line-height: 2rem">
				Featured Organization
			</p>
			<SearchCard
				:institution="featuredOrg"
				@searchDetails="handleSearchDetails"
				breakpoint="xs"
			/>
		</div>

		<div class="local-wrapper ma-4" v-if="showLocal">
			<v-row>
				<p class="title">Donate Local</p>
				<a
					v-if="zipLatLong"
					@click="changeZipCode"
					style="margin-top: 4px; margin-left: 8px"
					>{{ zipCode }}</a
				>
				<v-spacer></v-spacer>
				<a style="margin-top: 4px" @click="seeAllLocal">See All</a>
			</v-row>
			<v-row
				class="flex-nowrap"
				style="overflow-x: scroll !important"
				v-if="localLoading || zipLoading"
			>
				<v-card v-for="i in 10" :key="i" class="mr-2 ml-2 mb-2">
					<v-skeleton-loader
						min-width="200"
						type="card"
					></v-skeleton-loader>
				</v-card>
			</v-row>
			<v-row
				class="flex-nowrap"
				style="overflow-x: scroll !important"
				v-else
				id="donateLocalRow"
			>
				<v-card
					v-show="showZip"
					color="primary"
					class="pa-4 mt-3 zipCodeCard"
					style="
						min-height: 225px !important;
						height: 100% !important;
					"
					id="zipCodeCard"
				>
					<div
						style="
							width: 180px !important;
							height: 100% !important;
							min-height: 225px !important;
						"
					>
						<p>Want to donate locally? Enter your zipcode</p>
						<v-text-field
							placeholder="78722"
							v-model="zipCode"
							background="white"
							solo
							hide-details
							filled
							@update:error="(v) => (this.zipError = v)"
							:rules="[
								(v) =>
									!v ||
									v.length === 5 ||
									'Not a valid zip code',
								(v) =>
									!v ||
									!`${v}`.includes('.') ||
									'Not a valid zip code'
							]"
							type="number"
						/>
						<v-row style="margin-top: 16px !important">
							<v-spacer></v-spacer>
							<Roundup-Button
								@click="searchWithZip"
								color="white"
								:disabled="zipError"
								>Go</Roundup-Button
							>
							<v-spacer></v-spacer>
						</v-row>
					</div>
				</v-card>
				<SearchCard
					:key="i"
					v-for="(hit, i) in localList"
					:institution="hit"
					:showDescription="false"
					breakpoint="xs"
					@searchDetails="handleSearchDetails"
					class="ma-4"
					style="
						max-width: 400px !important;
						min-width: 270px !important;
						height: unset !important;
						min-height: 200px !important;
					"
				/>
			</v-row>
		</div>

		<SearchCategories
			defaultShow="true"
			@click="onShowAll"
			breakpoint="xs"
			:max="8"
			:categoryCount="8"
			:listDirection="categoryOrientation"
		/>
	</container>
</template>

<script>
import { Geolocation } from '@capacitor/geolocation'
import { mapActions, mapState } from 'vuex'
import { isIOS } from '@/utilities'
export default {
	name: 'search-home-component',
	props: {
		heroImage: {
			type: String,
			default:
				'https://roundup-website.s3.amazonaws.com/find-nonprofit-hero.jpg'
		},
		privateRoute: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapState({
			localList: ({ searchList }) => searchList.items,
			localLoading: ({ searchList }) => searchList.isFetching,
			aroundLatLong: ({ searchList }) => searchList.aroundLatLng
		}),
		hasUUID() {
			return !!process.env.VUE_APP_INSTITUTION_UUID
		},
		categoryOrientation() {
			return this.showLocal ? 'horizontal' : 'vertical'
		},
		showLocal() {
			return process.env.VUE_APP_SHOW_GIVE_LOCAL === 'true'
		}
	},
	data: () => {
		return {
			featuredOrg: null,
			searchRadius: 16000,
			showZip: true,
			zipCode: null,
			zipLoading: false,
			zipLatLong: null,
			zipError: false,
			GPSRequestInterval: null
		}
	},
	methods: {
		...mapActions([
			'updateFilters',
			'clearSearch',
			'getRandomInstitution',
			'getInstitution',
			'searchLocally',
			'zipToLatLong',
			'setSearchLatLong'
		]),

		scrollToTop() {
			if (this.$refs.searchbar) {
				const position =
					this.$refs.searchbar.$el.getBoundingClientRect()
				let offset = 16
				if (isIOS()) {
					offset = 40
				}
				window.scroll({
					top: position.y - offset,
					behavior: 'smooth'
				})
			}
		},
		onShowAll(cat) {
			if (cat) {
				this.onShowResults({ category: cat.title })
			} else {
				let route = this.privateRoute ? '' : 'public-'
				this.$router.push({ name: route + 'discover-categories' })
			}
		},

		onShowResults(params) {
			this.updateFilters(params)
			this.$emit('showResults', params)
			let route = this.privateRoute ? '' : 'public-'
			this.$router.push({
				name: route + 'discover-results',
				query: params
			})
		},

		async onFeelingLucky() {
			try {
				const inst = await this.getRandomInstitution()
				let route = this.privateRoute ? '' : 'public-'
				this.$router.push({
					name: route + 'discover-details',
					params: { uuid: inst.uuid }
				})
			} catch (e) {
				console.log(e)
				this.setAlert({
					alertText:
						'Uh-oh, something went wrong. Please try again later.',
					showAlert: true,
					alertColor: 'error'
				})
			}
		},

		handleSearchDetails(inst) {
			// if npm.buildpipe === component
			// this.$root.$emit(inst.uuid)
			this.$emit('searchDetails', this.featuredOrg)

			let route = this.privateRoute ? '' : 'public-'

			this.$router.push({
				name: route + 'discover-details',
				props: { uuid: inst.uuid },
				params: { uuid: inst.uuid, inst }
			})
		},
		onSearchLocal(lat, long, byIP = false) {
			this.showZip = false
			this.searchLocally({
				radius: this.searchRadius,
				lat,
				long,
				byIP
			}).then((data) => {
				if (!data.hits || data.hits.length < 10) {
					if (this.searchRadius > 50_000) {
						this.showZip = true
					} else {
						this.searchRadius = this.searchRadius * 10
						this.onSearchLocal(lat, long)
					}
				}
			})
		},
		async searchWithZip() {
			this.zipLoading = true
			localStorage.setItem('zipcode', this.zipCode)
			try {
				const mapData = await this.zipToLatLong(this.zipCode)
				this.zipLatLong = `${mapData.latitude},${mapData.longitude}`
				this.onSearchLocal(mapData.latitude, mapData.longitude, false)
			} catch (e) {
				console.log(e)
			}

			this.zipLoading = false
		},
		seeAllLocal() {
			this.$emit('showResults', {
				local: true,
				aroundLatLong: this.aroundLatLong,
				radius: this.searchRadius
			})
			let route = this.privateRoute ? '' : 'public-'
			this.$router.push({
				name: route + 'discover-results',
				query: {
					local: true,
					aroundLatLong: this.zipLatLong || this.aroundLatLong,
					radius: this.searchRadius
				}
			})
		},

		async getCurrentLocation() {
			Geolocation.getCurrentPosition()
				.then((position) => {
					this.zipLatLong = `${position.coords.latitude},${position.coords.longitude}`
					this.onSearchLocal(
						position.coords.latitude,
						position.coords.longitude,
						false
					)
				})
				.catch((error) => {
					// User denied geolocation
				})
		},
		changeZipCode() {
			this.showZip = true
			this.zipLoading = false

			const row = document.getElementById('donateLocalRow')
			var slideTimer = setInterval(function () {
				row.scrollLeft -= 100
				if (row.scrollLeft <= 0) {
					window.clearInterval(slideTimer)
				}
			}, 5)
		}
	},
	mounted() {
		this.updateFilters({
			category: null,
			subcategory: null,
			location: {
				city: null,
				state: null
			},
			zip: null,
			partner: null,
			query: null
		})

		this.clearSearch()
		if (this.hasUUID) {
			this.getInstitution(process.env.VUE_APP_INSTITUTION_UUID)
				.then((inst) => {
					this.featuredOrg = { ...inst, ...inst.brand }
					if (!this.privateRoute) {
						this.$router.push({
							name: 'public-discover-details',
							props: { uuid: this.featuredOrg.uuid },
							params: {
								uuid: this.featuredOrg.uuid,
								inst: this.featuredOrg
							}
						})
					}
				})
				.catch((e) => console.log(e))
		}
		const zip = localStorage.getItem('zipcode')
		if (zip) {
			this.zipCode = zip
			this.searchWithZip()
		} else {
			this.GPSRequestInterval = setInterval(() => {
				if (localStorage.getItem('has_onboarded') === 'true') {
					clearInterval(this.GPSRequestInterval)
					this.getCurrentLocation()
				}
			}, 500)
		}
	}
}
</script>

<style lang="scss" scoped>
.search-home {
	background: $white;
	.hero {
		margin-left: -16px !important;
		margin-right: -16px !important;
	}

	.hero > .col {
		display: flex;
		flex-direction: column;
		max-width: 100%;
		justify-content: center;
		align-items: center;
		flex: 0 0 100%;
	}
}

.search::v-deep .category-list-title {
	font-weight: 600;
}

.local-wrapper {
	.title {
		font-size: 1.5rem !important;
		font-weight: 400 !important;
		color: $roundup-charcoal !important;
		margin-left: 5px !important;
		font-family: $font-stack !important;
	}
	.zipCodeCard {
		margin-left: 12px !important;
		p {
			color: white !important;
			line-height: 1.3rem !important;
			font-weight: 400 !important;
			font-size: 1.25rem !important;
		}
		::v-deep .v-input__slot {
			&:hover {
				background-color: white !important;
			}
		}
	}
}
</style>
